'use strict'

const { pubdb } = Function('return this')();
const {
    $,
    foreach_key, review_sortable, display_pub, status_otf,
    add_toggle_diff, pub_dup_colors, window,
} = pubdb;
const { JsDiff, pub_dup } = window;
const { dict, colors, texts } = pub_dup;


review_sortable(0, 1);


status_otf(function (cb, shall_check) {
    let e;

    e = /^([a-z]+)-(\d+)-(\d+)$/.exec(cb.attr('name'));
    if (e) {
        const [/*void*/, name, p1, p2] = e;
        const args = [name, +p2];
        const op = shall_check ? 'set_nodup' : 'del_nodup';
        return [+p1, op, args];
    }

    e = /^(\d+)-(\d+)$/.exec(cb.attr('name'));
    if (e) {
        const [/*void*/, p1, p2] = e;
        const name = shall_check && shall_check.val() || null;
        const op = name ? 'set_nodup' : 'del_nodup';
        const args = [name, +p2];
        return [+p1, op, args];
    }
});


$(function () {
    $('.container').css({
        margin: 0,
        padding: 0,
        maxWidth: 'unset',
    });

    foreach_key(dict, function (k) {
        const pub = dict[k];
        display_pub([pub], $('#edit_table tbody .-pub-' + k));

        const { we: { id, name } } = pub;
        $('#edit_table tbody .-we-' + k).html($('<abbr/>', {
            text: id,
            title: name,
        }));
    });

    var count = 0, nodup = 0;
    $('#edit_table tbody tr').each(function () {
        if (add_toggle_diff(this, colors)) {
            ++nodup;
        }
        ++count;
    });

    $('<p/>', {
        text: `${texts[0]}: ${nodup - count} / ${count} ; ${texts[1]}: ${nodup} / ${count}`,
        insertBefore: '#edit_table'
    });

    add_toggle_diff('#edit_table');
});
